import {userActionTypes} from '../actions/userActionTypes';
import {participantActionTypes} from '../actions/participantActionTypes';

const initialState = { currentProgram:'esb', errors : {}, customerList:[],contractorList:[]};

export function authentication(state = initialState, action) {
  switch (action.type) {
    case userActionTypes.LOGIN_SET_FIELD:
      return {...state,
        [action.fieldName] : action.fieldVal,
        errors : {
          ...state.errors,
          [action.fieldName] : null
        }
      };
    case userActionTypes.SET_ACTIVE_PROGRAM:
        return {...state, currentProgram : action.programName };
    case userActionTypes.SET_SIDEBARMENU_COLLAPSE:
        return {...state, menuCollapse : action.menuCollapse };
    case userActionTypes.LOGIN_SET_ERROR:
      return {...state,
        errors: action.errors
      };
    case userActionTypes.LOGIN_REQUEST:
      return {...state,
        loggingIn: true,
        user: action.user
      };
    case userActionTypes.LOGIN_SUCCESS:
      return {...state,
        loggedIn: true
    };
    case userActionTypes.LOGIN_FAILURE:
      return {...state,
        errors: {...state.errors, ...action.errors}
      };
    case userActionTypes.GET_USER_DETAILS_SUCCESS:
      return {...state,
        adminUserInfo : action.userDetails
      };
    case userActionTypes.CHANGE_PASSWORD_REQUEST:
      return {...state,
        passwordChanging : true
    }; 
    case userActionTypes.CHANGE_PASSWORD_SUCCESS:
      return {...state,
        passwordChanging : false,
        passwordChanged: true
    }; 
    case userActionTypes.CHANGE_PASSWORD_FAILURE:
      return {...state,
        passwordChanging : false,
        passwordChanged : false,
        changePasswordError : action.error
    }; 
    case userActionTypes.CHANGE_PASSWORD_CLEAR:
      return {...state,
        passwordChanging : false,
        passwordChanged : false,
        changePasswordError: undefined
    };     
    case userActionTypes.PASSWORD_RESET_REQUEST:
      return {...state,
        passwordResetting : true
    }; 
    case userActionTypes.PASSWORD_RESET_SUCCESS:
      return {...state,
        passwordReset : true,
        passwordResetting:false
    };    
    case userActionTypes.PASSWORD_RESET_FAILURE:
      return {...state,
        passwordResetError : action.error,
        passwordReset : false,
        passwordResetting:false
    };  
    case userActionTypes.PASSWORD_RESET_CLEAR:
      return {...state,
        passwordResetError : null,
        passwordReset : false,
        passwordResetting:false
    };    
    case userActionTypes.EMAIL_VERIFICATION_REQUEST:
      return {...state,
        resendingEmail : true
    }; 
    case userActionTypes.EMAIL_VERIFICATION_SUCCESS:
      return {...state,
        emailResent : true,
        resendingEmail:false
    };  
    case participantActionTypes.RESET_EMAIL_VERIFICATION_MODAL:
      return {...state,
        emailResent : false,
        resendingEmail:false,
        resendingEmailError : false
   };    
    case userActionTypes.EMAIL_VERIFICATION_FAILURE:
      return {...state,
        resendingEmailError : action.error,
        emailResent : false,
        resendingEmail:false
    };   
    case userActionTypes.GET_ADMIN_USERS_REQUEST:
      return {...state,
        [`${action.userType}sLoading`] : true
    }; 
    case userActionTypes.GET_ADMIN_USERS_SUCCESS:
      return {...state,
        [`${action.userType}sLoading`] : false,
        [`${action.userType}List`] : action.data
    };     
    case userActionTypes.SHOW_LOGOUT_CONFIRMATION_MODAL:
      return { ...state,
        logoutConfirmationModalShown : action.show 
      };    
    case userActionTypes.SHOW_SUBMIT_PROFILE_MODAL:
      return { ...state,
        submitProfileModalShown : action.show 
      };    
    case userActionTypes.LOGOUT:
      return {...state,
        loggedIn : false,
        username : undefined,
        password : undefined
    };  
    case userActionTypes.SUBMIT_PROFILE_REQUEST:
      return {...state, submittingProfile: true };
    case userActionTypes.SUBMIT_PROFILE_SUCCESS:
      return {...state, submitProfileModalShown:false, submittingProfile : false, submittedProfileSuccessfully: true };
    case userActionTypes.SUBMIT_PROFILE_FAILURE:
      return {...state, submittingProfileError: action.error, submittingProfile: false };
    default:
      return state
  }
}